import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import "../Components/Upload/Index.css";
import { useSelector } from "react-redux";


const UploadIndex = () => {
    const { user, isAuth } = useSelector((state) => state.user);

    function handleType(val) {
        localStorage.setItem("contractType", val);
    }

    localStorage.setItem("contractType", "");
    localStorage.setItem("product", "");
    localStorage.setItem("company", "");
    
    useEffect(() => {
        if (isAuth && user && user.preferences) {
            const textSize = user.preferences.textSize;

            switch (textSize) {
                case 0: // Small
                    document.documentElement.style.setProperty('--font-size-header', '1.5vw');
                    document.documentElement.style.setProperty('--font-size-label', '14px');
                    document.documentElement.style.setProperty('--font-size-input', '14px');
                    document.documentElement.style.setProperty('--font-size-button', '0.8vw');
                    break;
                case 1: // Medium (default)
                    document.documentElement.style.setProperty('--font-size-header', '2vw');
                    document.documentElement.style.setProperty('--font-size-label', '16px');
                    document.documentElement.style.setProperty('--font-size-input', '16px');
                    document.documentElement.style.setProperty('--font-size-button', '1vw');
                    break;
                case 2: // Large
                    document.documentElement.style.setProperty('--font-size-header', '3vw');
                    document.documentElement.style.setProperty('--font-size-label', '24px');
                    document.documentElement.style.setProperty('--font-size-input', '24px');
                    document.documentElement.style.setProperty('--font-size-button', '2vw');
                    break;
                default:
                    break;
            }
        } else if (!isAuth) { 
            document.documentElement.style.setProperty('--font-size-header', '2vw');
            document.documentElement.style.setProperty('--font-size-label', '16px');
            document.documentElement.style.setProperty('--font-size-input', '16px');
            document.documentElement.style.setProperty('--font-size-button', '1vw');
          }
        }, [user, isAuth]);

    return (
    <>
        <div className="container5">
            <div className="header5">Analyze your contracts</div>
            <div className="question-and-button">
                <p>What is your contract type?</p>
                <div className="dropdown">
                    <select id="dropdownSelect" className="dropbutton" onChange={(e)=>handleType(e.target.value)}>
                        <option value="">Select an option</option>
                        <option value="Terms and Conditions">Terms and Conditions</option>
                        <option value="Private Policy">Private Policy</option>
                        <option value="Housing">Housing</option>
                        <option value="Other">Other</option>
                    </select>
                </div>
            </div>
            <div className="container2b">
                <Link to={"/fileupload"} id="goToUpload" className="upload-doc-button">
                    Upload your document
                </Link>
                <div className="header3">or</div>
                <Link to={"/pasteupload"} id="goToPaste" className="paste-doc-button">
                    Copy paste your document
                </Link>
            </div>
        </div>
    </>
  );
};

export default UploadIndex;
